import { useEffect, useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../context/AuthContext';
import { UsuarioService } from '../services/UsuarioService';

const RutaProtegida = ({ permiso, children }) => {
  const { usuario, token, setUsuario } = useAuth();
  const [verificando, setVerificando] = useState(true);
  const [autorizado, setAutorizado] = useState(false);
  const verificacionHecha = useRef(false);

  useEffect(() => {
    const verificarPermisos = async () => {
      try {
        const permisos = await UsuarioService.consultarPermisosPorUsuario({
          token,
          id: usuario.id,
        });
        
        const usuarioActualizado = {
          ...usuario,
          permisos,
        };
        setUsuario(usuarioActualizado);
        localStorage.setItem('user', JSON.stringify(usuarioActualizado));
        setAutorizado(permisos.includes(permiso));
      } catch (error) {
        console.error('Error al verificar permisos:', error);
        setAutorizado(false);
      } finally {
        setVerificando(false);
      }
    };

    if (!verificacionHecha.current) {
      verificacionHecha.current = true;
      verificarPermisos();
    }
  }, [permiso, token, setUsuario]);

  if (verificando) return null; // o un spinner

  if (!autorizado) return <Navigate to="/no-autorizado" replace />;

  return children;
};

RutaProtegida.propTypes = {
    permiso: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]).isRequired,
    children: PropTypes.node.isRequired
};

export default RutaProtegida;
